import {useSelector} from 'react-redux';
import {useWindowDimensions, ScrollView, StyleSheet, View, Image, TouchableOpacity, Linking} from 'react-native';
import {useState, useEffect} from 'react';
import {MenuNavigation} from 'interface/stacks/MenuNavigation';
import {MenuAccount} from 'interface/stacks/MenuAccount';
import {MenuStorage} from 'interface/stacks/MenuStorage';
import {MenuLinks} from 'interface/stacks/MenuLinks';
import {getHost, isNative, isUpsellDeniedPlatform} from 'utils/platform';
import {colors, breakpoints} from 'config/styles';
import {theme} from 'config/themes';

import * as app from 'store/slices/app';

const ADS = [
  {
    image: '/ads/myfiles_pro.jpg',
    url: 'https://www.mediafire.com/upgrade/get_plan.php?pid=premium_monthly&?utm_source=myfiles_pro',
    premium: false
  },
  {
    image: '/ads/myfiles_ultra.jpg',
    url: 'https://www.mediafire.com/upgrade/get_plan.php?pid=ultra_50_monthly&utm_source=myfiles_ultra',
    premium: false
  }
];

export function Menu() {
  const host = getHost();
  const screen = useWindowDimensions();
  const isBusiness = useSelector(app.selectors.isBusiness);
  const isPremium = useSelector(app.selectors.isPremium);
  const isPromoDisabled = isUpsellDeniedPlatform();
  const hasFloatingMenu = screen.width <= breakpoints.menu;
  const hasSidebarPromo = !isPromoDisabled && !isBusiness && !isNative();

  // Filter ads based on premium status
  // Premium users (Pro/Business) only see premium ads
  // Free/Trial/Unregistered users see all ads
  const availableAds = isPremium ? ADS.filter(ad => ad.premium) : ADS;

  const [currentAdIndex, setCurrentAdIndex] = useState(() => Math.floor(Math.random() * availableAds.length));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAdIndex(prevIndex => (prevIndex + 1) % availableAds.length);
    }, 60000); // 1 minute

    return () => clearInterval(interval);
  }, [availableAds.length]);

  // Reset index if it's out of bounds for the current ad set
  useEffect(() => {
    if (currentAdIndex >= availableAds.length) {
      setCurrentAdIndex(0);
    }
  }, [availableAds.length, currentAdIndex]);

  const selectedAd = availableAds.length > 0 ? availableAds[currentAdIndex] : null;
  const classes = {
    root: [
      styles.root,
      hasFloatingMenu && styles.floating,
    ],
  };

  return (
    <ScrollView
      style={classes.root}
      contentContainerStyle={styles.inner}
      showsVerticalScrollIndicator={false}
      accessibilityLabel="Main Menu">
      <View style={styles.content}>
        <View>
          <MenuAccount/>
          <View style={styles.divider}></View>
          <MenuNavigation/>
          <View style={styles.divider}></View>
          <MenuLinks/>
        </View>
        <View>
          {hasSidebarPromo && selectedAd &&
            <TouchableOpacity
              style={styles.promo}
              onPress={() => Linking.openURL(selectedAd.url)}
              accessibilityLabel="Advertisement"
            >
              <Image
                source={{uri: `${host}${selectedAd.image}`}}
                style={styles.adImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
          }
          <MenuStorage/>
        </View>
      </View>
    </ScrollView>
  );
}

export const styles = StyleSheet.create({
  root: {
    height: '100%',
    width: 200,
    borderRightWidth: 1,
    borderColor: theme.app.menu,
    backgroundColor: colors.neutral.dark,
  },
  inner: {
    flexGrow: 1,
  },
  content: {
    flex: 1,
    justifyContent: 'space-between',
  },
  floating: {
    borderRightWidth: 0,
  },
  divider: {
    height: 2,
    width: 168,
    marginVertical: 8,
    marginHorizontal: 16,
    backgroundColor: '#3d4350',
    overflow: 'visible',
  },
  promo: {
    width: 200,
    height: 306,
    marginVertical: 16,
  },
  adImage: {
    width: '100%',
    height: '100%',
  },
  fill: {
    flex: 1,
  },
});
